import type { CalendarWorkout, WorkoutDetail } from '../services/api';

export function workoutDetailToCalendarWorkout(detail: WorkoutDetail): CalendarWorkout {
  return {
    id: detail.id,
    workout_type: {
      id: detail.workout_type.id,
      name: detail.workout_type.name,
      english_name: detail.workout_type.english_name,
      icon: detail.workout_type.icon ?? '',
    },
    title: detail.title,
    workout_day: detail.workout_day,
    total_time: detail.total_time,
    total_time_planned: detail.total_time_planned,
    tss_actual: detail.tss_actual,
    tss_planned: detail.tss_planned,
    if_planned: detail.if_planned != null ? String(detail.if_planned) : null,
    description: detail.description,
    distance: detail.distance,
    distance_planned: detail.distance_planned,
    calories: detail.calories,
    order_on_day: null,
    is_created_by_athlete: false,
    structure: detail.structure,
    comments: Array.isArray(detail.comments) ? detail.comments.length : 0,
  };
}
